import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'device-catalog',
} as const satisfies Location
